var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader"},[_c('span',{staticClass:"preloader__item preloader__item1"}),_c('span',{staticClass:"preloader__item preloader__item2"}),_c('span',{staticClass:"preloader__item preloader__item3"}),_c('span',{staticClass:"preloader__item preloader__item4"})])
}]

export { render, staticRenderFns }